import { useLocale } from "../lib/i18n";

interface OfflineBannerProps {
  online: boolean;
}

export function OfflineBanner({ online }: OfflineBannerProps) {
  const { t } = useLocale();

  if (online) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-600 text-white text-center text-sm py-2 px-4">
      {t("offline.message")}
    </div>
  );
}
